/**
 * Modulo Core
 * @module abstracts/core
 * @namespace Abstracts/Core
 */

import Modules from './modules'

/**
 * Core do sistema, agregador de modulos
 *
 * @name Core
 * @memberof abstracts/core
 * @typedef {Object} Core
 */
class Core {
    // ###########################################################
    //
    // Módulos Backend
    //
    // ###########################################################

    /**
     * @property {Config}  Config - Modulo Config
     */
    Config

    /**
     * @property {Console}  Console - Modulo Console
     */
    Console

    /**
     * @property {Events}  Events - Modulo Events
     */
    Events

    /**
     * @property {Page}  Page - Modulo Page
     */
    Page

    /**
     * @property {Records}  Records - Modulo Records
     */
    Records

    /**
     * @property {Status}  Status - Modulo Status
     */
    Status

    /**
     * @property {Tasks}  Tasks - Modulo Tasks
     */
    Tasks

    // ###########################################################
    //
    // Módulos Frontend
    //
    // ###########################################################

    /**
     * @property {Lazyloading}  Lazyloading - Modulo Lazyloading
     */
    Lazyloading

    /**
     * @property {Visibility}  Visibility - Modulo Visbility
     */
    Visibility

    // ###########################################################
    //
    // Módulos Específicos do Core
    //
    // ###########################################################

    /**
     * @property {Modules}  Modules - Gerenciador de modulos
     */
    Modules

    // ###########################################################
    //
    // Variáveis estáticas
    //
    // ###########################################################

    /**
     * @property {Core}  instance - Instância estática do Core
     */
    static instance

    // ###########################################################
    //
    // Métodos útilizados apenas no Abstracts
    //
    // ###########################################################

    /**
     * Constructor singleton da classe Core
     *
     * @return {void}
     */
    constructor () {
        if (Core.instance) {
            return Core.instance
        }

        // Instância o gerenciador de modulos
        this.Modules = new Modules(this)

        // Cria a instância estática do Core
        Core.instance = this
    }

    /**
     * Inicializa o Core, carrega as depêndencias
     *
     * @return {void}
     */
    async start () {
        if (this._checkStarted()) {
            return
        }

        await this.Modules.loadScript()

        // Injeta os modulos backend no Core
        // this.Modules.load('Records')
        this.Modules.load('Status')
        this.Modules.load('Config')
        this.Modules.load('Console')
        this.Modules.load('Events')
        this.Modules.load('Tasks')
        this.Modules.load('Page')
        this.Modules.load('Externals')

        // Finaliza o processo do Core
        this.Status.update('core', 'status', 'finished')
    }

    /**
     * Verifica se o Core já não está inicializado
     *
     * @return {void}
     */
    _checkStarted () {
        if (this.Status && this.Status.get('core', 'status') === 'finished') {
            return true
        }

        return false
    }
}

const core = new Core()
export default core

// this.Tasks.add()

// this.Tasks.add(
//     ['core', 'page'],
//     [
//         "nome-script.js",
//         () => {
//             console.log("CALLBACK 01")
//         },
//         () => {
//             console.log("CALLBACK 02")
//         }
//     ]
// )

// this.Tasks.add(
//     this.Events.PAGE_COMPLETE,
//     [
//         "nome-script.js",
//         () => {
//             console.log("CALLBACK 03")
//         },
//         () => {
//             console.log("CALLBACK 04")
//         }
//     ]
// )

// // Callback
// this.Tasks.add(() => {
//     console.log("CALLBACK 05")
// })

// if(!watch) {
//     abstracts.watchOptions.ignored.push(path.resolve(__dirname, './**/*.js'))
// }
// // Script
// this.Tasks.add('script.js')

// // Evento , Callback
// this.Tasks.add(this.Events.PAGE_COMPLETE, () => {
//     console.log("CALLBACK 06")
// })

// // Entidades , Callback
// this.Tasks.add(['core', 'page'], () => {
//     console.log("CALLBACK 07")
// })

// // console.log(this.Tasks.getAll())

// this.Page = new Page()

// this.Status.update("core" , "status" , "started")
// this.Status.update("core" , "status" , "finished")
// this.Status.update("core" , "status" , "finished")
